const routes = [
  {
    path: '/oldprivacy',
    name: 'oldprivacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/oldPrivacy.vue'),
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/Privacy.vue'),
  },
  {
    path: '/argement',
    name: 'Argement',
    component: () => import(/* webpackChunkName: "about" */ '../views/argement.vue'),
  },
  {
    path: '/schemeLink',
    name: 'SchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/schemeLink.vue'),
  },
  {
    path: '/bfCallback',
    name: 'BfCallback',
    component: () => import(/* webpackChunkName: "about" */ '../views/bfCallback.vue'),
  },
  {
    path: '/electronicContract',
    name: 'electronicContract',
    component: () => import(/* webpackChunkName: "about" */ '../views/electronicContract.vue'),
  },
  {
    path: '/xcxSchemeLink',
    name: 'xcxSchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/xcxSchemeLink'),
  },
  {
    path: '/wxXcxSchemeLink',
    name: 'wxXcxSchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/wxXcxSchemeLink'),
  },
  {
    path: '/miniProgramRedirect',
    name: 'miniProgramRedirect',
    component: () => import(/* webpackChunkName: "miniProgramRedirect" */ '../views/miniProgramRedirect'),
    meta: { title: '极兔速递' },
  },
  {
    path: '/sendDetailOneYearNotify',
    name: 'sendDetailOneYearNotify',
    component: () => import(/* webpackChunkName: "about" */ '../views/checkGoods/sendDetailOneYearNotify'),
  },
  {
    path: '/monthXcxSchemeLink',
    name: 'monthXcxSchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/monthXcxSchemeLink'),
  },
  {
    path: '/childInformationProtection',
    name: 'childInformationProtection',
    component: () => import(/* webpackChunkName: "about" */ '../views/childRealName/childInformationProtection.vue'),
  },
  {
    path: '/childInformation',
    name: 'childInformation',
    component: () => import(/* webpackChunkName: "about" */ '../views/childRealName/childInformation.vue'),
  },
  {
    path: '/customerServiceCenterQa',
    name: 'customerServiceCenterQa',
    component: () => import(/* webpackChunkName: "about" */ '../views/customerServiceCenter/Qa.vue'),
    meta: {
      title: '客服中心'
    }
  },
  {
    path: '/serviceAgreementFengchao',
    name: 'serviceAgreementFengchao',
    component: () => import(/* webpackChunkName: "about" */ '../views/serviceAgreementFengchao.vue'),
    meta: {
      title: '丰巢寄件服务协议'
    }
  }
]

export default routes
